import { supabase } from '../auth/supabaseClient';

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

const getAccessToken = async () => {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token || null;
};

const authHeaders = async () => {
  const token = await getAccessToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

export const uploadEepromFile = async ({ file, module, selections, vin }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('module', module);
  formData.append('selections', JSON.stringify(selections || {}));
  if (vin) {
    formData.append('vin', vin);
  }

  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/eeprom/uploads`, {
    method: 'POST',
    headers,
    body: formData,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Upload failed');
  }

  return response.json();
};

export const createCheckout = async ({ uploadId }) => {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/payments/checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({ uploadId }),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Checkout failed');
  }

  return response.json();
};

export const downloadProcessedFile = async ({ uploadId }) => {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/eeprom/download/${uploadId}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Download failed');
  }

  return response.blob();
};

export const getUploadStatus = async ({ uploadId }) => {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/eeprom/uploads/${uploadId}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Failed to load upload status');
  }

  return response.json();
};

export const listEepromModules = async () => {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/eeprom/modules`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Failed to load modules');
  }

  return response.json();
};

export const updateEepromModulePrice = async ({ moduleKey, priceCents }) => {
  const headers = await authHeaders();
  const response = await fetch(`${API_BASE}/eeprom/modules/${moduleKey}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({ priceCents }),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || 'Failed to update price');
  }

  return response.json();
};
